const APIHOST = "https://api.nftencer.com/"; //https://api.coconut.global/

const ACCOUNT_PAGING = "account/paging?";
const LIMIT_ACCOUNT = "limit=100&offset=0";
const LIMIT_ACCOUNT_ID = "limit=1&offset=0";
const STASTUS_BLOCK = "&status=-1";
const ACCOUNT_PAGING_KEY = "account/search-paging?";
const NFT = "nft";
const collectible_id = "collectible_id=";
const account = "account";
const category = "category";
const trend = "trend";

export const SEARCH_ACCOUNT = APIHOST + ACCOUNT_PAGING + LIMIT_ACCOUNT;
export const SEARCH_ACCOUNT_KEY =
  APIHOST + ACCOUNT_PAGING + LIMIT_ACCOUNT_ID + "&key=";
export const SEARCH_ACCOUNT_BLOCK =
  APIHOST + ACCOUNT_PAGING + LIMIT_ACCOUNT + STASTUS_BLOCK;
export const SEARCH_ACCOUNT_KEY_BLOCK =
  APIHOST + ACCOUNT_PAGING + LIMIT_ACCOUNT_ID + STASTUS_BLOCK + "&key=";
export const SEARCH_PROFILE_API = APIHOST + "event?";
export const SEARCH_REPORT_API =
  APIHOST + "report?limit=99&offset=0&from=999999&to=0&";
export const SEARCH_UPDATE_REPORT_API = APIHOST + "report?&status=1&";
export const ADD_REPORT_API = APIHOST + "status?status=1&";
export const REMOVE_REPORTT_API = APIHOST + "status?&status=0&";
export const BLOCK_USER_API = APIHOST + NFT + "/block?" + collectible_id;
export const SEARCH_DASBOARD_API =
  APIHOST + account + "/paging?" + LIMIT_ACCOUNT + "keys=";
export const SEARCH_DASBOARD_ID_API = APIHOST + account + "?id=";
export const COLLECTIBLE_PAGING_API =
  APIHOST +
  NFT +
  "/collectible-paging?cursor=&limit=99&sort=desc&filter=created-date&title=&address=";
export const SEARCH_ALL_BANNER_API =
  APIHOST + "banner/paging?status=0&limit=99&offset=0";
export const SEARCH_BANNER_API = APIHOST + "banner?";
export const CATEGORY_API = APIHOST + category;
export const EVENT_API = APIHOST + "event/paging?status=0&limit=99&offset=0";
export const SEARCH_EVENTID_API = APIHOST + "event/?id=";
export const SEARCH_ITEMID_API = APIHOST + NFT + "?id=";
export const BLOCK_ACCOUNT_API = APIHOST + "account/block?id=";
export const SEARCH_BLOCK_ACCOUNT_BLOCK_API =
  APIHOST +
  NFT +
  "collectible-paging?cursor=&limit=999&sort=desc&filter=created-date&title=&address=";
export const GET_TREND_API = APIHOST + trend;
export const ADD_TREND_API = APIHOST + trend + "?advertisement=true&";
export const DELETE_NTF_API = APIHOST + NFT + "?id=";
export const GET_COLLECTIBLE_API =
  APIHOST +
  NFT +
  "/collectible-paging?limit=1000&sort=desc&filter=created-date";
export const GET_COMMENT_API =
  APIHOST + "comment/paging?limit=99&offset=999&collectible_id=";
export const DELETE_COMMENT_API = APIHOST + "/comment?id=";
export const BLOCK_ITEM_API = APIHOST + NFT + "/block?collectible_id=";
